var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.width > 0 && _vm.height > 0)?_c('v-chart',{ref:"echart",staticClass:"chart",class:_vm.hasUpdated ? 'faded-in' : 'hidden',attrs:{"option":_vm.option}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }